import { rangeHandleWidth } from '../../css/redesign/exports/misc.scss'

up.compiler('.js-range', function (wrapper) {
  const handleWidth = parseInt(rangeHandleWidth, 10)
  const range = wrapper.querySelector('input[type="range"]')
  // a range's thumb cannot have :before/:after pseudoelements
  // so we need to add an explicit element
  const handleHoverBackground = wrapper.querySelector('.js-range__handle_hover_background')
  const currentValue = wrapper.querySelector('.js-range__legend__current')
  const labels = JSON.parse(wrapper.dataset.labels)
  const precision = parseInt(wrapper.dataset.precision, 10)

  function getPercentage(range) {
    const min = range.min
    const max = range.max
    const val = range.value

    return ((val - min) * 100) / (max - min)
  }

  function updateCurrentValue(range) {
    // update text
    const label = labels[`${(range.value * 1).toFixed(precision)}`]
    currentValue.querySelector('[aria-hidden=true]').innerHTML = label.label
    currentValue.querySelector(':not([aria-hidden=true])').innerHTML = label.aria_label

    // update position
    const percentage = getPercentage(range)

    if (percentage < 50) {
      currentValue.style.left = `max(0px, calc(${percentage}% - ${handleWidth * ((percentage - 50) / 100)}px))`
      currentValue.style.right = ''
      currentValue.style.marginLeft = ''
      currentValue.style.marginRight = ''
      currentValue.style.transform = 'translateX(-50%)'
    } else {
      currentValue.style.left = ''
      currentValue.style.right = `max(0px, calc(${100 - percentage}% - ${
        (handleWidth * (100 - (percentage + 50))) / 100
      }px))`
      currentValue.style.marginLeft = ''
      currentValue.style.marginRight = ''
      currentValue.style.transform = 'translateX(50%)'
    }

    const currentValueRect = currentValue.getBoundingClientRect()
    const wrapperRect = wrapper.getBoundingClientRect()

    // after centering the value with transform, it might overflow out of the container
    // if it does, we need to adjust the position further
    // so that it's as centered as possible, but doesn't overflow
    const tooLeft = Math.min(currentValueRect.x - wrapperRect.x, 0)

    const tooRight = Math.min(wrapperRect.x + wrapperRect.width - (currentValueRect.x + currentValueRect.width), 0)
    if (tooLeft) {
      currentValue.style.marginLeft = -1 * tooLeft + 'px'
    }
    if (tooRight) {
      currentValue.style.marginRight = -1 * tooRight + 'px'
    }
  }

  function update(range) {
    const percentage = getPercentage(range)
    handleHoverBackground.style.left = `calc(${percentage}% - ${(handleWidth * percentage) / 100}px)`
    range.style.backgroundSize = percentage + '% 100%'
    updateCurrentValue(range)
  }

  function handleInputChange(e) {
    update(e.target)
  }

  update(range)

  range.addEventListener('input', handleInputChange)
  // VoiceOver doesn't trigger input events on ranges, so we also need to handle change events
  range.addEventListener('change', handleInputChange)

  return function () {
    range.removeEventListener('input', handleInputChange)
    range.removeEventListener('change', handleInputChange)
  }
})
